import axios from "api/axios"
import {
  APIResponse,
  APIResponseOld,
  Config,
  ConfigWithURLParams,
  NoContentType,
} from "api/types"
import {
  formatErrorResponse,
  formatErrorResponseOld,
  formatSuccessResponse,
  formatSuccessResponseOld,
} from "api/utils"

import {
  BlockedUser,
  FetchUserResponse as FetchUserResponse,
  LearningUser,
  OrganizationUser,
  OrganizationUserUpdateBody,
  UpdateUserPreferenceResponse,
  UserAttributes,
  UserPreference,
} from "./types"
import { urls } from "./urls"

export default {
  block: {
    list: async (): Promise<APIResponse<BlockedUser[]>> => {
      try {
        const res = await axios.get(urls.block.list())
        return formatSuccessResponse(res)
      } catch (e) {
        return formatErrorResponse(e)
      }
    },
    delete: async ({
      urlParams,
    }: ConfigWithURLParams): Promise<APIResponse<NoContentType>> => {
      try {
        const res = await axios.delete(urls.block.delete(urlParams.id))
        return formatSuccessResponse(res)
      } catch (e) {
        return formatErrorResponse(e)
      }
    },
  },
  getUserPreferences: async (): Promise<APIResponse<UserPreference[]>> => {
    try {
      const res = await axios.get(urls.config.preferences())
      return formatSuccessResponse(res)
    } catch (e) {
      return formatErrorResponse(e)
    }
  },
  updateUserPreferences: async ({
    data,
  }: Config): Promise<APIResponseOld<UpdateUserPreferenceResponse[]>> => {
    try {
      const res = await axios.post(urls.config.preferences(), data)
      return formatSuccessResponseOld(res)
    } catch (e) {
      return formatErrorResponseOld(e)
    }
  },

  getUserAttributes: async (): Promise<APIResponse<UserAttributes>> => {
    try {
      const res = await axios.get(urls.config.attributes())
      return formatSuccessResponse(res)
    } catch (e) {
      return formatErrorResponse(e)
    }
  },
  updateUserAttributes: async ({
    data,
  }: Config): Promise<APIResponse<UserAttributes>> => {
    try {
      const res = await axios.put(urls.config.attributes(), data)
      return formatSuccessResponse(res)
    } catch (e) {
      return formatErrorResponse(e)
    }
  },

  getUser: async (): Promise<APIResponse<LearningUser>> => {
    try {
      const res = await axios.get(urls.user())
      return formatSuccessResponse(res)
    } catch (e) {
      return formatErrorResponse(e)
    }
  },
  updateUser: async ({ data }: Config): Promise<APIResponse<LearningUser>> => {
    try {
      const res = await axios.put(urls.user(), data)
      return formatSuccessResponse(res)
    } catch (e) {
      return formatErrorResponse(e)
    }
  },
  createLead: async ({ data }: Config): Promise<APIResponse<NoContentType>> => {
    try {
      const res = await axios.post(urls.leads(), data)
      return formatSuccessResponse(res)
    } catch (e) {
      return formatErrorResponse(e)
    }
  },
  getUserDetails: async ({
    data,
  }: Config): Promise<APIResponse<FetchUserResponse>> => {
    try {
      const res = await axios.post(urls.getUserDetails(), data)
      return formatSuccessResponse(res)
    } catch (e) {
      return formatErrorResponse(e)
    }
  },

  getOrganizationUser: async (): Promise<APIResponse<OrganizationUser>> => {
    try {
      const res = await axios.get(urls.organizationUser())
      return formatSuccessResponse(res)
    } catch (e) {
      return formatErrorResponse(e)
    }
  },
  updateOrganizationUser: async (
    data: OrganizationUserUpdateBody
  ): Promise<APIResponse<OrganizationUser>> => {
    try {
      const res = await axios.put(urls.organizationUser(), data)
      return formatSuccessResponse(res)
    } catch (e) {
      return formatErrorResponse(e)
    }
  },
}
